import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useParams, useNavigate } from 'react-router-dom';
import {
  ArrowLeftIcon,
  DocumentTextIcon,
  ReceiptPercentIcon,
  EnvelopeIcon,
  UserCircleIcon,
  WrenchScrewdriverIcon,
  CalendarDaysIcon,
  BanknotesIcon,
} from '@heroicons/react/24/solid';
import { collection, doc, getDoc, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../../firebase';

const tabs = [
  {
    name: 'Propuestas',
    to: 'proposal',
    icon: DocumentTextIcon,
  },
  {
    name: 'Facturas',
    to: 'invoices',
    icon: ReceiptPercentIcon,
  },
  {
    name: 'Mensajes',
    to: 'email',
    icon: EnvelopeIcon,
  },
  {
    name: 'Perfil',
    to: 'profile',
    icon: UserCircleIcon,
  },
  {
    name: 'Agenda',
    to: 'agenda',
    icon: CalendarDaysIcon,
  },
  {
    name: 'Seguimiento',
    to: 'tracking',
    icon: WrenchScrewdriverIcon, // o cualquier otro icono
  },
  {
    name: 'Servicio',
    to: 'service',
    icon: WrenchScrewdriverIcon,
  },
  {
    name: 'Mensualidad y acuerdo',
    to: 'maintenance',
    icon: BanknotesIcon,
  },
];

const ClientLayout = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const [clientName, setClientName] = useState('');

  useEffect(() => {
    let active = true;
    const loadClientName = async () => {
      if (!clientId) {
        setClientName('');
        return;
      }
      try {
        const directRef = doc(db, 'clients', clientId);
        const directSnap = await getDoc(directRef);
        if (directSnap.exists()) {
          if (!active) return;
          const data = directSnap.data() || {};
          setClientName(data.businessName || data.name || data.email || '');
          return;
        }

        const decodedEmail = decodeURIComponent(clientId).toLowerCase();
        const matchSnap = await getDocs(
          query(collection(db, 'clients'), where('email', '==', decodedEmail), limit(1))
        );
        if (!active) return;
        if (!matchSnap.empty) {
          const data = matchSnap.docs[0].data() || {};
          setClientName(data.businessName || data.name || data.email || '');
        } else {
          setClientName('');
        }
      } catch (err) {
        console.warn('⚠️ No se pudo obtener el nombre del cliente:', err.message);
        if (active) setClientName('');
      }
    };

    loadClientName();
    return () => {
      active = false;
    };
  }, [clientId]);

  const displayName = clientName || clientId;

  return (
    <div className="p-4 max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <button
          onClick={() => navigate('/admin/clients')}
          className="flex items-center gap-2 text-sm text-gray-600 hover:text-orange-600 transition"
        >
          <ArrowLeftIcon className="h-5 w-5" />
          Volver a Clientes
        </button>
        <h2 className="text-lg font-semibold text-gray-800">Cliente: {displayName}</h2>
      </div>

      {/* Subnavigation */}
      <nav className="flex flex-nowrap gap-3 mb-6 overflow-x-auto pb-2">
        {tabs.map(({ name, to, icon: Icon }) => (
          <NavLink
            key={to}
            to={`/admin/clients/${clientId}/${to}`}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-2 text-sm rounded-full font-medium transition shrink-0 ${
                isActive
                  ? 'bg-orange-100 text-orange-700'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`
            }
          >
            <Icon className="w-5 h-5" />
            {name}
          </NavLink>
        ))}
      </nav>

      {/* Vista interna */}
      <div className="bg-white rounded-lg shadow p-4">
        <Outlet />
      </div>
    </div>
  );
};

export default ClientLayout;
